import { iOntology, iLabel } from '@gloow/apiconsumer'

export const isOntology = (data: iLabel | iOntology | Partial<iLabel>) => {
  // @ts-ignore
  if (typeof data.ontologyClass === 'undefined') return true
  return false
}
